<h1 mat-dialog-title>{{ 'scheduler.setup.availabilityCode.single.add' | translate }}</h1>

<form (ngSubmit)="addAvailabilityCode()" [formGroup]="availabilityCodeForm">

  <mat-icon color="accent">description</mat-icon>
  <mat-form-field>
    <mat-label>Description</mat-label>
    <input formControlName="AvailabilityCodeDescription" matInput required type="text">
    @if (availabilityCodeForm.controls['AvailabilityCodeDescription']) {
      <mat-error>Please enter availability code
        description !
      </mat-error>
    }
  </mat-form-field>

  <mat-icon color="accent">type</mat-icon>
  <mat-form-field>
    <mat-label>Code Type</mat-label>
    <mat-select formControlName="AvailabilityType">
      <mat-option [value]="'BLOCK'">
        Unavailability
      </mat-option>
      <mat-option [value]="'ASSIGN'">
        Additional Shift
      </mat-option>
      <!--      <mat-option [value]="'EXTEND'">-->
      <!--        Extension-->
    <!--      </mat-option>-->
  </mat-select>
</mat-form-field>

<mat-dialog-actions>
  <span class="spacer"></span>
  <button (click)="onCancelButton()" mat-flat-button type="reset">Cancel</button>
  <button [disabled]="!availabilityCodeForm.valid" color="primary" mat-raised-button type="submit">Add</button>
</mat-dialog-actions>

</form>